


export const utilService = {
    appendQueryParams,
    getData,

    updateDocumentTitle,
    getIpAddress,
}




function appendQueryParams(url: string, params: Record<string, any>): URL {
    const apiUrl = new URL(url);
    for (const key in params) {
        if (params[key] !== undefined && params[key] !== null) {
            apiUrl.searchParams.append(key, params[key]);
        }
    }
    return apiUrl;
}

async function getData(response: Response): Promise<any> {
    let responseData = await response.text();
    if (responseData.charCodeAt(0) === 0xfeff) {
        responseData = responseData.substr(1);
    }
    const trimmedData = responseData.trim();
    const json = JSON.parse(trimmedData);
    return json;
}





function updateDocumentTitle(location: Location) {
    let title;
    switch (location.pathname) {
        case '/careers':
            title = 'Careers';
            break;
        case '/open-positions':
            title = 'Open Positions';
            break;
        case '/job':
            title = 'Job';
            break;
        case '/apply-form':
            title = 'Apply Form';
            break;
        case '/privacy-policy':
            title = 'Candidates Privacy Notice';
            break;
        default:
            title = 'Home'; // Default title for the root or any undefined path
    }
    document.title = `HAAT Careers | ${title}`;
}



async function getIpAddress() {
    try {
        const response = await fetch('https://api.ipify.org/?format=json');

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();

        return data.ip;
    } catch (error) {
        console.error('There was a problem fetching the IP address:', error);
    }
}